// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductList_container__3_oER","container__total":"ProductList_container__total__N_auM"};